<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Native New Yorkers, brother and sister team, Tom Johnson and Deborah Ettinger were inspired by the early life of their mother and uncle during the turbulent times of the Great Depression, Spanish Flu Pandemic, Prohibition and WWII. A graduate of Fordham University, Tom is a Bronze Star recipient and veteran of the Vietnam War. Deborah graduated from St Vincent’s School of Nursing and Hunter College. After highly successful careers in healthcare, Tom as assistant professor at Long Island University and Deborah as senior vice president of an international health system, they returned to their love of storytelling.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?49b89ded